/*
 * Follows the product's Style option (T-Shirt, Sweatshirt, Hoodie...): a
 * block's text swaps to its version for other garments, and the title's
 * garment word to the selected style, so the page always describes the
 * garment on screen.
 *
 * Liquid (snippets/style-text.liquid, snippets/product-style-title.liquid)
 * already renders the variant the page opens with; this only follows later
 * changes.
 */
if (!customElements.get('style-text')) {
  customElements.define(
    'style-text',
    class StyleText extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.show(data.variant));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      show(variant) {
        const style = variant?.options?.[Number(this.dataset.optionPosition) - 1];
        if (!style) return;

        const isForStyles = this.dataset.styles.split('|').includes(style.trim().toLowerCase());
        this.querySelectorAll('[data-style-text]').forEach((text) => {
          text.hidden = (text.dataset.styleText === 'styles') !== isForStyles;
        });
      }
    }
  );
}

/*
 * The product title with its garment word following the selected style
 * (snippets/product-style-title.liquid holds one title per style).
 */
if (!customElements.get('style-title')) {
  customElements.define(
    'style-title',
    class StyleTitle extends HTMLElement {
      connectedCallback() {
        this.titles = JSON.parse(this.dataset.titles);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.show(data.variant));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      show(variant) {
        const style = variant?.options?.[Number(this.dataset.optionPosition) - 1];
        const title = style && this.titles[style.trim().toLowerCase()];
        if (title) this.textContent = title;
      }
    }
  );
}
